import { Text } from 'components'
import styled from 'styled-components'
import { colors } from 'utils/colors'

export default function InlineEditBtn() {
  return (
    <EditBtn data-testid="hover_edit_btn">
      <Text color="blue1" fontSize="14px" fontWeight="bold" lineHeight="20px" padding="0px 12px">
        edit_lbl
      </Text>
    </EditBtn>
  )
}

export const EditBtn = styled.button`
  height: 33px;
  background: linear-gradient(${colors.gray1}, ${colors.gray1} 80%);
`
